import React from 'react';
import logoImage from '../../logo1.png';

interface LogoImageProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}

export function LogoImage({ size = 'md', showText = true, className = '' }: LogoImageProps) {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16'
  };

  const textSizes = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-3xl'
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Logo Image */}
      <div className={`${sizeClasses[size]} relative flex items-center justify-center`}>
        <img 
          src={logoImage} 
          alt="MacTrack Logo" 
          className="w-full h-full object-contain"
        />
      </div>

      {/* Text */}
      {showText && (
        <h1 className={`font-bold text-text-dark tracking-tight ${textSizes[size]} flex items-center leading-none`}>
          MacTrack
        </h1>
      )}
    </div>
  );
}

// Alternative version with fade-in animation
export function LogoImageAnimated({ size = 'md', showText = true, className = '' }: LogoImageProps) {
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16'
  };

  const textSizes = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-3xl'
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Logo Image with Animation */}
      <div className={`${sizeClasses[size]} relative flex items-center justify-center`}>
        <img 
          src={logoImage} 
          alt="MacTrack Logo" 
          className={`w-full h-full object-contain transition-all duration-700 ease-out ${
            isLoaded ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
          }`}
          onLoad={() => setIsLoaded(true)}
        />
      </div>

      {/* Text with Animation */}
      {showText && (
        <h1 className={`font-bold text-text-dark tracking-tight ${textSizes[size]} transition-all duration-700 ease-out flex items-center leading-none ${
          isLoaded ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4'
        }`} style={{ animationDelay: '0.3s' }}>
          MacTrack
        </h1>
      )}
    </div>
  );
} 